// extracted by mini-css-extract-plugin
export var createdDate = "_il-1";
export var divider = "_il-2";
export var headerDivider = "_il-3";
export var messagesCard = "_il-0";
export var messagesContainer = "_il-6";
export var messagesContainerWrapper = "_il-4";
export var showLeftPanelButton = "_il-8";
export var topButtons = "_il-7";
export var withPadding = "_il-5";